import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from "react";
import { Label, RadioGroup, RadioGroupItem } from "../../../components/base";
import { FieldDescription } from "../FieldDescription";
export const RadioField = ({ field, value, disabled, error, onChange, }) => {
    const uniqueId = useId();
    const options = field.options ?? [];
    return (_jsxs("div", { className: "space-y-1", children: [_jsxs(Label, { className: "text-xs", children: [field.question, " ", field.required && _jsx("span", { className: "text-red-500", children: "*" })] }), _jsx(FieldDescription, { ...field }), _jsx(RadioGroup, { value: value ?? "", onValueChange: onChange, disabled: disabled, className: error ? "rounded-md border border-red-500 p-2" : undefined, children: options.map((opt, idx) => {
                    const optionId = `${uniqueId}-${field.name}-${opt.value || idx}`;
                    return (_jsxs("div", { className: "flex items-center gap-2", children: [_jsx(RadioGroupItem, { value: opt.value, id: optionId }), _jsx(Label, { htmlFor: optionId, className: "text-sm font-normal", children: opt.label })] }, opt.value || idx));
                }) }), error && _jsx("p", { className: "text-xs text-red-500", children: error })] }));
};
export const validateRadioField = (field, value, t) => {
    if (!field.required)
        return undefined;
    const str = value === undefined || value === null ? "" : String(value);
    if (str.trim() === "") {
        return t("form.validation.required");
    }
    return undefined;
};
export const serializeRadioField = (field, value) => {
    const options = Array.isArray(field.options) ? field.options : [];
    const found = options.find((o) => o.value === value);
    return found ? found.label : value;
};
//# sourceMappingURL=RadioField.js.map